import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import DashboardLayout from '../Layout/DashboardLayout';
import AuthLayout from '../Layout/AuthLayout';
import OnboardingLayout from '../Layout/OnboardingLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import Login from '../pages/Login/Login';
import NotFound from '../pages/Error/NotFound';
import LiveDeals from '../pages/LiveDeals/LiveDeals';
import SignupAs from '../pages/Signup/SignupAs';
import EnrollAs from '../pages/Signup/EnrollAs';
import Signup from '../pages/Signup/Signup';
import Orders from '../pages/Orders/Orders';
import Reports from '../pages/Reports/Reports';
import Wallet from '../pages/Wallet/Wallet';
import Support from '../pages/Support/Support';
import DealDetails from '../pages/LiveDeals/Components/DealDetails';
import OrderSummary from '../pages/LiveDeals/Components/OrderSummary';
import Agreement from '../pages/LiveDeals/Components/Agreement';
import SuccessfulDealBuy from '../pages/LiveDeals/Components/SuccessfulDealBuy';
import ForgotPassword from '../pages/Login/ForgotPassword';
import Otp from '../pages/Login/Otp';
import ChangePassword from '../pages/Login/ChangePassword';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import Onboarding from '../pages/Onboarding/Onboarding';
import Profile from '../pages/Profile/Profile';
import Notifications from '../pages/Notifications/Notifications';
import Kyc from '../pages/Kyc/Kyc';
import KycLayout from '../Layout/KycLayout';
import Sla from '../pages/Sla/Sla';
import SlaLayout from '../Layout/SlaLayout';
import ErrorUI from '../pages/Error/ErrorUI';
import PdfViewer from '../components/CustomPdfViewer/PdfViewer';
import NomineeLayout from '../Layout/NomineeLayout';
import Nominee from '../pages/Nominee/Nominee';
import BoardResolution from '../pages/BoardResolution/BoardResolution';
import BoardLayout from '../Layout/BoardLayout';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="login" />,
    },
    {
        path: '/',
        element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
        errorElement: <ErrorUI />,
        children: [
            { path: 'dashboard', element: <Dashboard /> },
            { path: 'live-deals', element: <LiveDeals /> },
            { path: 'deal-details', element: <DealDetails /> },
            { path: 'order-summary', element: <OrderSummary /> },
            { path: 'agreement', element: <Agreement /> },
            { path: 'success', element: <SuccessfulDealBuy /> },
            { path: 'orders', element: <Orders /> },
            { path: 'reports', element: <Reports /> },
            { path: 'wallet', element: <Wallet /> },
            { path: 'support', element: <Support /> },
            { path: 'profile', element: <Profile /> },
            { path: 'notifications', element: <Notifications /> },
            { path: '/view-pdf/:pdfName', element: <PdfViewer /> },
        ],
    },
    {
        path: '/kyc',
        element: <KycLayout />,
        errorElement: <ErrorUI />,
        children: [
            { path: '', element: <Kyc /> },
        ],
    },
    {
        path: '/nominee',
        element: <NomineeLayout />,
        errorElement: <ErrorUI />,
        children: [
            { path: '', element: <Nominee /> },
        ],
    },
    {
        path: '/sla',
        element: <SlaLayout />,
        errorElement: <ErrorUI />,
        children: [
            { path: '', element: <Sla /> },
        ],
    },
    {
        path: '/board-resolution',
        element: <BoardLayout />,
        errorElement: <ErrorUI />,
        children: [
            { path: '', element: <BoardResolution /> },
        ],
    },
    {
        path: '/onboarding',
        element: <OnboardingLayout />,
        errorElement: <ErrorUI />,
        children: [
            { path: '', element: <Onboarding /> },
        ],
    },
    {
        path: '/',
        element: <PublicRoute><AuthLayout /></PublicRoute>,
        // errorElement: <ErrorUI />,
        children: [
            { path: 'login', element: <Login /> },
            { path: 'signup-as', element: <SignupAs /> },
            { path: 'enroll-as', element: <EnrollAs /> },
            { path: 'signup', element: <Signup /> },
        ],
    },
    {
        path: 'forgot-password',
        element: <PublicRoute><ForgotPassword /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: 'otp',
        element: <PublicRoute><Otp /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: 'change-password',
        element: <PublicRoute><ChangePassword /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
], {
    future: {
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_relativeSplatPath: true,
        v7_skipActionErrorRevalidation: true,
        v7_startTransition: true,
    }
});

export default router;
